import React from 'react';
import { IS_SAAS } from '../../config/edition';

// Группы разделов админки. badge: (state) => number|null — счётчик для пункта.
const GROUPS = [
  { title: 'Люди', items: [
    { key: 'users', label: 'Пользователи' },
    { key: 'domains', label: 'Домены' },
  ]},
  { title: 'Платформа', items: [
    // Метрики платформы — инструмент администратора: вся аудитория, разрезы по
    // сервисам, таблица людей. Личные цифры человека живут отдельным экраном
    // «Метрики» в основном меню (UserMetrics), и смешивать их незачем.
    { key: 'metrics', label: 'Метрики платформы' },
    { key: 'queue', label: 'Очередь' },
    { key: 'abandoned', label: 'Брошенные задачи' },
  ]},
  // Раздел целиком относится к нашей продаже: заявки на счёт и пробный месяц.
  // В издании onprem его нет — bit-billing в состав стенда и клиентской установки
  // не входит, и обе вкладки отдавали бы 502.
  { title: 'Биллинг', saasOnly: true, items: [
    { key: 'billing', label: 'Заявки на счёт' },
    { key: 'trials', label: 'Пробный месяц' },
    { key: 'organizations', label: 'Организации' },
    { key: 'payments', label: 'Оплаты и доля офисов' },
  ]},
  { title: 'Конфигурация', items: [
    { key: 'prompts', label: 'Промпты' },
    { key: 'rates', label: 'Себестоимость' },
    { key: 'settings', label: 'Настройки' },
  ]},
];

// Ключи всех разделов — один источник для навигации и для разбора адреса.
// 🔴 Второй список ключей заводить нельзя. 21.09.2026 «Организации» добавили в
// боковую панель и в карту вкладок, но забыли в белом списке разбора хеша в
// AdminPanel: первый клик ставил адрес и тут же откатывался на «Пользователей»
// по событию hashchange, второй клик адрес не менял и потому работал. Прямая
// ссылка на раздел и перезагрузка страницы уводили туда же.
const TAB_KEYS = GROUPS.flatMap((g) => g.items.map((i) => i.key));

/**
 * Навигация Админки по артборду «Админка» (docs/redesign/2026-09-04-bumaga/
 * Newton - Админка.dc.html): колонка 248px без рамки, группы капсом, пункты
 * скруглением 10 и без иконок — тот же язык, что у главной боковой панели.
 */
export default function AdminSidebar({ active, onSelect, badges = {} }) {
  return (
    <nav className="w-[248px] shrink-0 flex flex-col gap-[2px] self-start">
      {GROUPS.filter((g) => !g.saasOnly || IS_SAAS).map((g) => (
        <div key={g.title} className="flex flex-col gap-[2px]">
          <div className="px-3 pb-[6px] pt-[14px] font-mono text-[11px] uppercase tracking-[0.1em] text-paper-ink-3">
            {g.title}
          </div>
          {g.items.map((it) => {
            const badge = badges[it.key];
            const on = active === it.key;
            return (
              <button
                key={it.key}
                type="button"
                onClick={() => onSelect(it.key)}
                className={`flex w-full items-center justify-between gap-2 rounded-[10px] px-3 py-2
                            text-left text-[14px] transition-colors ${
                  on ? 'bg-paper-card font-semibold text-paper-ink'
                     : 'font-medium text-paper-ink-2 hover:bg-paper-panel'}`}
              >
                <span className="truncate">{it.label}</span>
                {badge ? (
                  <span className={`shrink-0 rounded-badge px-[6px] py-[1px] text-[11px] font-semibold ${
                    it.key === 'users' ? 'bg-paper-accent/[0.12] text-paper-accent'
                                       : 'bg-paper-bg text-paper-ink-2'}`}>
                    {badge}
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>
      ))}
    </nav>
  );
}

export { GROUPS, TAB_KEYS };
